export default class ExportGenerator {
  constructor(config) {
    this.$container = config.$container;
    this.csvUrl = undefined;
    this.exportId = config.exportId;
  }

  init() {
    this._initListeners();
    return this;
  }

  _initListeners() {
    this.$container.hide();
    this.pollEndpoint();
  }

  pollEndpoint() {
    if (this.csvUrl) {
      if (this.$container.is(":visible")) return;

      $('#loading-message').hide();
      this.$container.show();

      return;
    }

    $.get(`/export/waiting_students.json?export_id=${this.exportId}`, (data) => {
      this.csvUrl = data.url;
      this.fileName = data.file_name;
      setTimeout(this.pollEndpoint.bind(this), 2500);
    });
  }
}
